<style>
    .cdk-overlay-container {
        z-index: 2000;
    }

    /*.cdk-overlay-pane {
        position: absolute;
        pointer-events: auto;
        box-sizing: border-box;
        z-index: 1000;
        display: flex;
        max-width: 100%;
        max-height: 100%;
    }

    ::ng-deep .cdk-overlay-container mat-datepicker-content {
        z-index: 2000;
    }*/

    svg:focus {
        outline: none !important;
    }

    button:focus {
        outline: none !important;
    }
</style>



<div class=" modal-content"
    style="border-radius:0px; font-family: sans-serif !important; height: 100%; overflow: hidden; margin: 0px; padding: 0px; width: 100% !important; position: relative;">
    <div>
        <!--Header-->
        <div class="modal-header">
            <!-- WebView Header-->
            <div class="col-md-12 col-sm-12 col-12 webView">
                <div class="row">
                    <div class="col-md-3 col-3" style="padding-left: 0px;">
                        <h4 class="modal-title"><span id="ApntmntHdr">{{ !isEdit ? 'Enter ' : 'Edit '}}Voucher</span>
                        </h4>
                    </div>
                    <div class="col-md-3 col-sm-3">
                        <span style="float: right; top: 5px; position: relative;"
                            [hidden]="data.imbalance == '0' || data.imbalance == '0 Cr' || data.imbalance == '0 Db'">
                            Imbalance : ₹ {{data.imbalance | cRDB}}
                        </span>
                    </div>
                    <div class="col-md-6 col-6 col-6" style="padding: 0px; text-align: right;">

                        <div class="btn orangeButton" (click)="openVoucherHistory(myModal)" title="Audit Trail"
                            style="font-size: 13px; display: inline-block; margin-right: 10px" *ngIf="isEdit">
                            <i class="fa fa-history" aria-hidden="true" style="margin-right: 5px;"></i>Audit Trail
                        </div>

                        <div class="btn orangeButton" (click)="printVoucher()"
                                style="display: inline-block; margin-right: 10px" *ngIf="isEdit">
                                <i class="zmdi zmdi-print" aria-hidden="true"></i>
                        </div>

                        <div class="btn orangeButton" (click)="printVoucherReceipt()" style="display: inline-block; margin-right: 10px" 
                            *ngIf="showPrintReceiptBtn && data.isSavePaymentReceipt && data.voucherID > 0">
                            <span style="font-size: 13px;"> 
                                <i class="zmdi zmdi-print" aria-hidden="true" style="margin-right: 7px;"></i>Print Receipt</span> 
                        </div>

                        <div class="btn orangeButton" (click)="openLedgerModal(ledgerEntry, false)" *ngIf="right.AcctsCfg" style="margin-right: 5px;
                            font-size: 13px; cursor: pointer;">
                            <i class="zmdi zmdi-plus" style="margin-right: 5px;"></i> Add Ledger
                        </div>

                        <div class="btn orangeButton" *ngIf="isEdit && right.AcctsVchrEdit" (click)="deleteVoucherOpenPopup(voucherID)"
                            style="margin-left: 5px;font-size: 13px; margin-right: 5px;">
                            <i aria-hidden="true" class="fa fa-trash" style="margin-right: 8px;">
                            </i>Delete
                        </div>

                        <div class="btn orangeButton" *ngIf="isEdit && docDetails.DocID > 0 && docDetails.DocType == 'DINV'" (click)="openDocsPrint()"
                            style="cursor:pointer; border-radius: 3px; margin-left: 5px;font-size:13px;margin-right: 5px;">
                            <span><i class="fa fa-file" style="font-size: 13px; margin-right: 5px;"></i>
                                View {{docDetails.DocName}} {{docDetails.DocNo}}
                            </span> 
                        </div>

                        <div class="label orangeButton fntSz ng-star-inserted" *ngIf="isEdit && docDetails.DocID > 0 && docDetails.DocType != 'DINV'" 
                            style="cursor:context-menu !important;  margin-left: 5px;font-size:13px; margin-right: 5px;">
                            <span><i class="fa fa-file" style="font-size: 13px; margin-right: 5px;"></i>
                                {{docDetails.DocName}} {{docDetails.DocNo}}
                            </span> 
                        </div>

                        <span class="btn btn-save brdrRadius3" (click)="save()" *ngIf="right.AcctsVchrEntry || (isEdit && right.AcctsVchrEdit)"
                            style="margin-left:5px;line-height: 22px; font-size: 13px;padding: 3px 7px 3px;">
                            <i class="fa fa-check" style="margin-right: 5px;"></i>
                            <span>Save</span>
                        </span>

                        <!-- <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeEntryModal(true)"></i> -->
                    </div>
                </div>
            </div>

            <!-- Mobile View Header -->
            <div class="col-md-12 col-sm-12 col-12 mobView">
                <div class="row">
                    <div class="col-md-4 col-6" style="padding: 0px;">
                        <h4 class="modal-title"><span id="ApntmntHdr">{{ !isEdit ? 'Enter ' : 'Edit '}}Voucher</span>
                        </h4>
                    </div>
                    <div class="col-md-2 col-2 col-6" style="display: flex; justify-content: flex-end; padding-right: 0px;">
                        <span class="btn btn-darkGreen brdrRadius3" (click)="save()"  *ngIf="right.AcctsVchrEntry || (isEdit && right.AcctsVchrEdit)"
                            style="margin-right: 5px;line-height: 23px;font-size: 14px; padding: 1px 7px 1px; align-self: center;">
                            <i class="fa fa-check" style="margin-right: 5px;"></i>
                            <span>Save</span>
                        </span>

                        <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeEntryModal(false)"></i>
                    </div>
                </div>
            </div>
        </div>

        <!--Body-->
        <div class="modal-body" style="margin: 0px;">
            <!--Body-->

            <!-- Wbview -> Voucher Type + Voucher No-->
            <div class="col-md-12 col-12 col-12 pad0 webView">
                <div class="row">
                    <!--Voucher Type-->
                    <div class="col-md-4 col-12" style="margin-top: 5px;max-width: 20% !important;">
                        <select class="form-control" id="voucherType" [(ngModel)]="data.voucherType" tabindex="1"
                            placeholder="Select Voucher Type" style="cursor: pointer;"
                            (ngModelChange)="voucherTypeChanged($event)">
                            <option label="Select Voucher Type"></option>
                            <option *ngFor="let a of type" [ngValue]="a.name">{{a.name}}</option>
                        </select>

                    </div>

                    <!--Voucher No-->
                    <div class="col-md-4 col-12" style="margin-top: 5px;max-width: 20% !important;">
                        <input type="text" name="vNO" [(ngModel)]="data.voucherNO" id="vNO" placeholder="Voucher No."
                            class="form-control" tabindex="1">
                        <span style="font-size: 11px; color: #777;" [hidden]="data.previouNo == ''">Prev. Voucher No.:
                            {{data.previouNo}}</span>
                    </div>

                    <!--Voucher Date-->
                    <div class="col-md-4 col-12" style="margin-top: 0px;">
                        <div
                            style="width: 100%; outline: none !important; font-size: 14px !important; line-height: normal;">
                            <input [min]="minDate" [max]="maxDate" matInput readonly [matDatepicker]="picker" (focus)="picker.open()" 
                                class="form-control" (ngModelChange)="vchrDTChange($event)"
                                [(ngModel)]="data.voucherDate" tabindex="1"
                                style="display: inline-block; width: 80px; background: #FFF;">
                            <mat-datepicker-toggle matSuffix [for]="picker"
                                style="display: inline-block; position: relative; top: 5px;"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </div>

                    </div>
                </div>
            </div>

            <!-- MobileView -> Voucher Type + Voucher No-->
            <div class="col-md-12 col-12 col-12 pad0 mobView">
                <div class="row">
                    <!--Voucher Type-->
                    <div class="col-md-4 col-12" style="margin-top: 5px;">
                        <select class="form-control form-control-mob" id="voucherType" [(ngModel)]="data.voucherType" tabindex="1"
                            placeholder="Select Voucher Type" style="cursor: pointer;"
                            (ngModelChange)="voucherTypeChanged($event)">
                            <option label="Select Voucher Type"></option>
                            <option *ngFor="let a of type" [ngValue]="a.name">{{a.name}}</option>
                        </select>

                    </div>

                    <!--Voucher No-->
                    <div class="col-md-4 col-7" style="margin-top: 10px;">
                        <input type="text" name="vNO" [(ngModel)]="data.voucherNO" id="vNO" placeholder="Voucher No."
                            class="form-control form-control-mob" tabindex="1">
                        <span style="font-size: 11px; color: #777;" [hidden]="data.previouNo == ''">Prev. Voucher No.:
                            {{data.previouNo}}</span>
                    </div>

                    <!--Voucher Date-->
                    <div class="col-md-4 col-5" style="margin-top: 4px; padding: 0px;">
                        <div
                            style="width: 100%; outline: none !important; font-size: 14px !important; line-height: normal;">
                            <input [min]="minDate" [max]="maxDate" matInput readonly [matDatepicker]="picker1" (focus)="picker.open()"
                                class="form-control form-control-mob" [(ngModel)]="data.voucherDate" tabindex="1"
                                style="display: inline-block; width: 80px; background: #FFF;">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </div>
                    </div>
                </div>
            </div>

            <!--Table + Webview-->
            <div class="col-md-12 col-sm-12 col-xs-12 pad0 webView" style="margin-top: 25px;">
                <table class="table table-bordered ng-table">
                    <thead>
                        <tr>
                            <th style="width: 30%;">
                                <h5 style="font-size: 14px !important;color: #333333 !important;">Ledger</h5>
                            </th>
                            <th style="width: 12%;">
                                <h5 style="font-size: 14px !important;color: #333333 !important;">Credit (₹)</h5>
                            </th>
                            <th style="width: 12%;">
                                <h5 style="font-size: 14px !important;color: #333333 !important;">Debit (₹)</h5>
                            </th>
                            <th style="width: 12%;">
                                <h5 style="font-size: 14px !important;color: #333333 !important;">Curr. Bal. (₹)</h5>
                            </th>
                            <th style="width: 33%;">
                                <h5 style="font-size: 14px !important;color: #333333 !important;">Narration</h5>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <!--List-->
                        <tr *ngFor="let a of dataTbl; let i = index">
                            <!--Ledger-->
                            <td>
                                <input class="form-control wid100" list="ledger" [(ngModel)]="a.ledgerName" tabindex="1"
                                    placeholder="Select Ledger" (blur)="ledgerChng(a.ledgerName, i)">
                                <datalist id="ledger">
                                    <option *ngFor="let l of ledgers" [value]="l.Ledger">{{l.Ledger}}</option>
                                </datalist>

                                <!-- <select class="form-control" style="box-shadow: none;" [(ngModel)]="a.ledgerID" tabindex="1" (ngModelChange)="ledgerChng($event, data.ledgerID)">
                                    <option value="0" style="color: #777;">Select Ledger</option>
                                    <option value="{{l.LedgerID}}" *ngFor="let l of ledgers;">{{l.Ledger}}</option>
                                </select> -->
                            </td>
                            <!--Credit-->
                            <td>
                                <input type="text" name="crID1" [(ngModel)]="a.credit" id="crID1 " class="form-control"
                                    (keypress)="numberOnly($event)" (paste)="numberOnlyPaste($event)"
                                    style="text-align: right;" tabindex="1" (blur)="changeCrDbVal(i, 'C');">
                            </td>

                            <!--Debit-->
                            <td>
                                <input type="text" name="dbID1" [(ngModel)]="a.debit" id="dbID1 " class="form-control"
                                    (keypress)="numberOnly($event)" (paste)="numberOnlyPaste($event)"
                                    style="text-align: right;" tabindex="1" (blur)="changeCrDbVal(i, 'D');">
                            </td>

                            <!--Curr. Bal-->
                            <td style="text-align: right;">
                                <!--<input type="text" name="curBal1" id="curBal1" [(ngModel)]="a.curBal" class="form-control" (keypress)="numberOnly($event)" disabled="disabled" style="text-align: right;">-->
                                <span>{{a.curBal | lacFormat}} {{a.curBalType}}</span>
                            </td>

                            <!--Notes-->
                            <td>
                                <input type="text" name="notes1" [(ngModel)]="a.notes" id="notes{{i}}"
                                    class="form-control" tabindex="1">
                            </td>
                        </tr>

                        <!--Add-->
                        <tr>
                            <!--Ledger-->
                            <td>
                                <!-- <select class="form-control" style="box-shadow: none;" [(ngModel)]="data.ledgerID" (ngModelChange)="ledgerChng($event, data.ledgerID)" tabindex="1">
                                    <option value="0" style="color: #777;">Select Ledger</option>
                                    <option value="{{a.LedgerID}}" *ngFor="let a of ledgers;">{{a.Ledger}}</option>
                                </select> -->

                                <input class="form-control wid100" list="ledgerData" id="firstInput"
                                    [(ngModel)]="data.ledgerName" (blur)="ledgerChng(data.ledgerName, -1)" tabindex="1"
                                    placeholder="Select Ledger">
                                <datalist id="ledgerData">
                                    <option *ngFor="let l of ledgers" [value]="l.Ledger">{{l.Ledger}}</option>
                                </datalist>
                            </td>

                            <!--Credit-->
                            <td>
                                <input type="text" name="crID1" [(ngModel)]="data.credit" class="form-control"
                                    (keypress)="numberOnly($event)" (paste)="numberOnlyPaste($event)"
                                    style="text-align: right;" (blur)="onBlurEvent($event,data)" tabindex="1">
                            </td>

                            <!--Debit-->
                            <td>
                                <input type="text" name="dbID1" [(ngModel)]="data.debit" id="lastInput"
                                    class="form-control" (keypress)="numberOnly($event)"
                                    (paste)="numberOnlyPaste($event)" style="text-align: right;"
                                    (blur)="onBlurEvent($event,data)" tabindex="1">
                            </td>

                            <!--Curr. Bal-->
                            <td style="text-align: right;">
                                <!--<input type="text" name="curBal1" [(ngModel)]="data.curBal" id="curBal1" class="form-control" (keypress)="numberOnly($event)" style="text-align: right;" onkeypress="return save();">-->
                                <span>{{data.curBal | lacFormat}} {{data.curBalType}}</span>

                            </td>

                            <!--Notes-->
                            <td>
                                <input type="text" name="notes1" [(ngModel)]="data.notes" id="notes1"
                                    class="form-control" tabindex="1">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!---Mobile view-->
            <!--List-->
            <div class="col-md-12 col-12 pad0 mobView whiteCard" *ngFor="let a of dataTbl; let i = index;"
                style="margin-top: 15px; padding: 15px; border-radius: 3px; font-size: 13px;">
                <div class="row">
                    <!--Ledger-->
                    <div class="col-md-12 col-12">
                        <!-- <select class="form-control" style="box-shadow: none;" [(ngModel)]="a.ledgerID" (ngModelChange)="ledgerChng($event, data.ledgerID)">
                            <option value="0" style="color: #777;">Select Ledger</option>
                            <option value="{{l.LedgerID}}" *ngFor="let l of ledgers;">{{l.Ledger}}</option>
                        </select> -->

                        <input class="form-control form-control-mob wid100" list="ledgerData" [(ngModel)]="a.ledgerName"
                            (blur)="ledgerChng(a.ledgerName, i)" placeholder="Select Ledger">
                        <datalist id="ledgerData">
                            <option *ngFor="let l of ledgers" [value]="l.Ledger">{{l.Ledger}}</option>
                        </datalist>
                    </div>

                    <!--Credit + Debit + Current Bal-->
                    <div class="col-md-12 col-12" style="margin-top: 10px;">
                        <div class="row">
                            <!--Credit + Debit-->
                            <div class="col-md-6 col-6">
                                <span style="display: inline-block;">Credit : </span>
                                <input type="text" name="crID2" placeholder="0.00" [(ngModel)]="a.credit" id="crID2" class="form-control form-control-mob"
                                    (keypress)="numberOnly($event)" (focus)="onFocusEvent($event)" (blur)="changeCrDbVal(i, 'C');"
                                    style="text-align: right; display: inline-block; width: 45%; margin-left: 15px;">
                            </div>
                            <div class="col-md-6 col-6">
                                <span style="display: inline-block">Debit : </span>
                                <input type="text" name="dbID1" placeholder="0.00" [(ngModel)]="a.debit" id="dbID1" class="form-control form-control-mob"
                                    (keypress)="numberOnly($event)" (focus)="onFocusEvent($event)" (blur)="changeCrDbVal(i, 'D');"
                                    style="text-align: right; display: inline-block; width: 45%; margin-left: 15px;">
                            </div>
                        </div>
                    </div>

                    <!-- Current Bal-->
                    <div class="col-md-12 col-12" style="margin-top: 10px;">
                        <span style="display: inline-block">Curr. Bal. : </span>
                        <span style="margin-left: 10px;"> ₹ {{a.curBal}} {{a.curBalType}}</span>
                    </div>

                    <!--Note-->
                    <div class="col-md-12 col-12" style="margin-top: 10px;">
                        <input type="text" placeholder="Note" name="notes1" [(ngModel)]="a.note" id="notes1"
                            class="form-control form-control-mob" tabindex="1">
                    </div>
                </div>
            </div>

            <!--Add-->
            <div class="col-md-12 col-12 pad0 mobView whiteCard"
                style="margin-top: 25px; padding: 15px; border-radius: 3px;">
                <div class="row">
                    <!--Ledger-->
                    <div class="col-md-12 col-12">
                        <!-- <select class="form-control" style="box-shadow: none;" [(ngModel)]="data.ledgerID" (ngModelChange)="ledgerChng($event, data.ledgerID)" tabindex="1">
                            <option value="0" style="color: #777;">Select Ledger</option>
                            <option value="{{a.LedgerID}}" *ngFor="let a of ledgers;">{{a.Ledger}}</option>
                        </select> -->

                        <input class="form-control form-control-mob wid100" list="ledgerData" [(ngModel)]="data.ledgerName"
                            (blur)="ledgerChng(data.ledgerName, -1)" placeholder="Select Ledger">
                        <datalist id="ledgerData">
                            <option *ngFor="let l of ledgers" [value]="l.Ledger">{{l.Ledger}}</option>
                        </datalist>
                    </div>

                    <!--Credit + Debit-->
                    <div class="col-md-12 col-12" style="margin-top: 15px;font-size: 13px;">
                        <div class="row">
                            <div class="col-md-6 col-6">
                                <span style="display: inline-block">Credit : </span>
                                <input type="text" name="crID1" placeholder="0" [(ngModel)]="data.credit"
                                    id="crID1" class="form-control form-control-mob" (focus)="onFocusEvent($event)" (keypress)="numberOnly($event)"
                                    style="font-size: 13px !important; text-align: right; display: inline-block; width: 45%; margin-left: 15px;"
                                    (blur)="onBlurEvent($event,data)" tabindex="1">
                            </div>

                            <div class="col-md-6 col-6">
                                <span style="display: inline-block">Debit : </span>
                                <input type="text" name="dbID1" placeholder="0" [(ngModel)]="data.debit" id="dbID1"
                                    class="form-control form-control-mob" (focus)="onFocusEvent($event)" (keypress)="numberOnly($event)"
                                    style="font-size: 13px !important;text-align: right; display: inline-block; width: 45%; margin-left: 15px;"
                                    (blur)="onBlurEvent($event,data)" tabindex="1">
                            </div>
                        </div>
                    </div>

                    <!-- Current Bal-->
                    <div class="col-md-12 col-12" style="margin-top: 15px;font-size: 13px;">
                        <span style="display: inline-block">Curr. Bal. : </span>
                        <!--<input type="text" name="curBal1" [(ngModel)]="data.curBal" id="curBal1" class="form-control" (keypress)="numberOnly($event)" disabled="disabled" style="text-align: right; display: inline-block; width: 100px;" onkeypress="return save();" tabindex="1">-->
                        <span style="margin-left: 10px; font-size: 13px !important;">₹ {{data.curBal}}
                            {{data.curBalType}}</span>
                    </div>

                    <!--Note-->
                    <div class="col-md-12 col-12" style="margin-top: 15px;">
                        <input type="text" name="notes1" placeholder="Note" [(ngModel)]="data.notes" id="notes1"
                            class="form-control form-control-mob" tabindex="1">
                    </div>
                </div>
            </div>


            <!--Notes-->
            <div class="col-md-12 col-sm-12 col-xs-12 pad0itm pad0" style="margin-top: 15px;">
                <!-- <input type="text" tabindex="1" class="form-control" placeholder="Notes" style="padding: 3px; border: 1px solid #ddd; height: 40px;" ng-model="data.details" /> -->
                <textarea type="text" tabindex="1" class="form-control" placeholder="Common Notes"
                    style="padding: 3px; height: 60px; resize: none; border-radius: 3px !important; padding: 10px;" maxlength="1000"
                    [(ngModel)]="data.details"></textarea>
            </div>

            <!--Bank Info-->
            <div class="col-md-12 col-sm-12 col-xs-12 webView" style="margin-top: 20px;" *ngIf="data.isPaymentShow">
                <div class="row">
                    <!--Payment mode-->
                    <div class="col-md-3 col-12" style="padding: 0px;">
                        <select class="form-control" style="box-shadow: none;" [(ngModel)]="data.payMode" tabindex="1">
                            <option value="0" style="color: #777;">Select Payment Mode</option>
                            <option value="Cash">Cash</option>
                            <option value="Cheque">Cheque</option>
                            <option value="Demand Draft">Demand Draft</option>
                            <option value="IMPS">IMPS</option>
                            <option value="Intra-Bank">Intra-Bank</option>
                            <option value="NEFT">NEFT</option>
                            <option value="RTGS">RTGS</option>
                            <option value="UPI">UPI</option>
                            <option value="Card">Card</option>
                        </select>
                    </div>

                    <!--Payment ref-->
                    <div class="col-md-3 col-12 mobPay">
                        <input type="text" name="payRef" maxlength="20" [(ngModel)]="data.payRef" id="payRef"
                            placeholder="Payment Ref." class="form-control" tabindex="1">
                    </div>
                </div>
            </div>

            <!-- Update Recovery Amount -->
            <div class="col-md-12 col-sm-12 col-xs-12 pad0itm pad0" style="margin-top: 15px;" 
            *ngIf="isShowUpdateRecovery && voucherID == 0">
                <label style="color:#15304a">
                    <input type="checkbox" [(ngModel)]="data.isUpdateRecAmt" (change)="changeRecvry($event)">
                    <span style="margin-left: 10px;">Update customer receivable to ₹
                        <input type="text" class="form-control" style="width: 100px; text-align: right;" [(ngModel)]="data.recAmt" maxlength="9" 
                        [disabled]="!data.isUpdateRecAmt" appTwoDecimalNumber/>
                        after saving this voucher.
                    </span>
                </label>
            </div>

            <!-- Update Invoice Status -->
            <div class="col-md-12 col-sm-12 col-xs-12 pad0itm pad0" style="margin-top: 15px;" 
                *ngIf="isShowUpdateRecovery && voucherID == 0">
                <label style="color:#15304a">
                    <input type="checkbox" [(ngModel)]="data.isUpdateinvStatus">
                    <span style="margin-left: 10px;">Update invoice status
                    </span>
                </label>
            </div>

            <!-- Cash Receipt for -->
            <div class="col-md-12 col-sm-12 col-xs-12 pad0itm pad0" style="margin-top: 15px; font-size: 13px;" *ngIf="data.voucherTypeID == 2 || data.voucherTypeID == 4">
                <label style="color:#15304a; cursor: pointer; display: inline-block;">
                    <input type="checkbox" [(ngModel)]="data.isSavePaymentReceipt">
                    <span style="margin-left: 10px;">Print Receipt </span>
                    <div style="display: inline-block;" *ngIf="data.isSavePaymentReceipt == true">
                        <span style="display: inline-block;">for </span>
                        <input type="text" class="form-control" [(ngModel)]="data.partyName"
                            style="display: inline-block; width: 222px; margin-left: 10px; cursor: default;">
                    </div>
                </label>
            </div>

            <!--File-->
            <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="margin-top: 10px;">
                <span class="btn font13 lableBtnOrange padLeft5 brdrRadius3 hvrInfo btnBottom"
                    style="width: fit-content; padding: 5px 12px"
                    (click)="addAttechmentFile()" *ngIf="!fileName && !data.dbVoucherFile">
                    <i class="zmdi zmdi-file-plus" style="padding-right: 10px;"></i>Upload File
                </span>

                <!-- <a class="btn btn-yellow webView" href="../../main.html#/Docs?M=6" style="padding: 5px 14px 4px; font-size: 14px; display: inline-block; line-height: 1.66em; 
                margin-left: 10px; text-decoration: none !important; box-shadow: none !important;" target="_blank" title="Purchases"><i _ngcontent-nkv-c1="" aria-hidden="true"
                 class="fa fa-shopping-cart headerIcon" style="margin-right: 5px;"></i> Purchases </a> -->

                <input type="file" id="addAttechment" fileread="fileUpload.val"
                    (change)="handleFileInput($event.target.files)" 
                    accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.zip,.rar,.gzip,.tiff,.btif"
                    style="display: none;">
                <div *ngIf="fileName || data.dbVoucherFile" style="font-size: 14px; position: relative; top: 5px;">
                    <span style="margin-right: 3px;">File : </span>
                    {{fileName ? fileName : data.dbVoucherFile}}
                    <i class="fa fa-trash lightGreyBkgd" title="Remove File"
                        style="cursor: pointer; font-size: 16px; margin-left: 5px; margin-right: 5px; color: gray"
                        (click)="removeAttechUploadedFile()"></i>
                </div>
            </div>

        </div>

        <!--Footer-->
        <!-- WebView Footer -->
        <div class="modal-footer col-md-12 col-sm-12 col-xs-12 webView"
            style="border: none; text-align: left; float: left; justify-content: left !important; padding: 0px 15px 20px;">
            <span class="btn btn-save brdrRadius3" (click)="save()"  *ngIf="right.AcctsVchrEntry"
                style="font-size: 13px; padding: 2px 7px 2px; line-height: 1.66em;">
                <i class="fa fa-check" style="margin-right: 5px;"></i>
                <span>Save</span>
            </span>
            <span style="margin-left: 10px"
                [hidden]="data.imbalance == '0' || data.imbalance == '0 Cr' || data.imbalance == '0 Db'">
                Imbalance : ₹ {{data.imbalance | cRDB}}
            </span>
            <span *ngIf="!showLearningMaterial && showOnBoarding" (click)="openHelpPage(11)" class="trngDarkBlueBtn" style="margin-left: 10px; padding: 2px 7px !important;">
                <i class="fa fa-question" style="margin-right: 5px; vertical-align: initial; font-size: 16px;"></i> Need Help
            </span>
        </div>
        
        <!-- MobView Footer -->
        <div class="mobView" style="margin: 1rem; margin-top: 0px;">
                <div style="margin-bottom: 10px;">
                    <span
                        [hidden]="data.imbalance == '0' || data.imbalance == '0 Cr' || data.imbalance == '0 Db'">
                        Imbalance : ₹ {{data.imbalance | cRDB}}
                    </span>
                </div>
                <div>
                    <span class="btn btn-darkGreen brdrRadius3" (click)="save()"  *ngIf="right.AcctsVchrEntry"
                        style="margin-right: 10px; line-height: 23px; font-size: 14px; padding: 1px 7px 1px;">
                        <i class="fa fa-check" style="margin-right: 5px;"></i>
                        <span>Save</span>
                    </span>
                    <span class="btn darkBlueBadge brdrRadius3" (click)="closeEntryModal(false)" style="margin-right: 10px; line-height: 24px; font-size: 14px; padding: 1px 7px 1px;">
                        <i class="fa fa-close" style="margin-right: 5px;"></i>
                        <span>Close</span>
                    </span>
                </div>
                
                <span *ngIf="!showLearningMaterial && showOnBoarding" (click)="openHelpPage(11)" class="trngDarkBlueBtn" style="margin-left: 10px; padding: 2px 7px !important;">
                    <i class="fa fa-question" style="margin-right: 5px; vertical-align: initial; font-size: 16px;"></i> Need Help
                </span>
        </div>
    </div>
</div>

<!--Ledger Entry Modal-->
<ng-template #ledgerEntry let-modal>
    <!--Header-->
    <div class="modal-header">
        <div class="col-md-12 col-sm-12 col-12">
            <div class="row">
                <div class="col-md-9 col-sm-10 col-10" style="padding-left: 0px;">
                    <h4 class="modal-title"><span id="ApntmntHdr">Add Ledger</span></h4>
                </div>
                <div class="col-md-3 col-sm-2 col-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" data-dismiss="modal" style="float: right;"
                        (click)="modal.dismiss('Cross click')"></i>
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="font-size: 13px !important;">
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px;">
            <div class="col-md-4 col-sm-4 col-5" style="padding: 0px; display: inline-block; color: #333333;">
                Parent Group :
            </div>
            <div class="col-md-8 col-sm-8 col-8" style="display: inline-block; padding: 0px;">
                <select class="form-control wid75" [(ngModel)]="newLedger.accountHead"
                    style="padding-left: 0px !important;">
                    <option value="0">Select</option>
                    <option *ngFor="let sh of headData" [value]="sh.HeadID">{{sh.HeadName}}</option>
                </select>
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
            <div class="col-md-4 col-sm-4 col-5" style="padding: 0px; display: inline-block; color: #333333;">
                Ledger Name :
            </div>
            <div class="col-md-8 col-sm-8 col-8" style="display: inline-block; padding: 0px;">
                <input type="text" class="form-control wid75" [(ngModel)]="newLedger.ledgerName" id="txtNewLedger">
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
            <div class="" style="display: inline-block; line-height: 40px; color: #333333; width: 30%;">Link with :
            </div>
            <div class="budge2 btn lableBtnOrange padLeft5 hvrInfo brdrRadius3 btnBottom {{ newLedger.type == 0 ? 'lableBtnOrange-active' : '' }}"
                style="font-size: 13px; margin-left: 0px;" (click)="ledgerType(0)">None</div>
            <div class="budge2 btn lableBtnYellow padLeft5 hvrInfo  brdrRadius3 btnBottom {{ newLedger.type == 1 ? 'lableBtnYellow-active' : '' }}"
                style="font-size: 13px; margin-left: 0px;" (click)="ledgerType(1)">Customer</div>
            <div class="budge2 btn lableBtGreenMain padLeft5 brdrRadius3 hvrInfo btnBottom {{ newLedger.type == 2 ? 'lableBtGreenMain-active' : '' }}"
                style="font-size: 13px;" (click)="ledgerType(2)">Supplier</div>
            <div class="budge2 btn lableBtTill padLeft5 hvrInfo brdrRadius3 btnBottom {{ newLedger.type == 3 ? 'lableBtTill-active' : '' }}"
                style="font-size: 13px;" (click)="ledgerType(3)">Bank</div>
            <div class="budge2 btn lableBtnDarkBlue padLeft5 brdrRadius3 hvrInfo btnBottom {{ newLedger.type == 4 ? 'lableBtnDarkBlue-active' : '' }}"
                style="font-size: 13px;" (click)="ledgerType(4)">Cash</div>
            <div class="budge2 btn lableBtTill padLeft5 hvrInfo brdrRadius3 btnBottom {{ newLedger.type == 5 ? 'lableBtTill-active' : '' }}"
                style="font-size: 13px; display: none;" (click)="ledgerType(5)">Employee</div>
        </div>

        <!-- <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;" *ngIf="newLedger.type == 0">
           
        </div> -->

        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;" *ngIf="newLedger.type == 1">
            <div class="col-md-4 col-sm-4 col-4" style="padding: 0px; display: inline-block; color: #333333;">Customer :
            </div>
            <div class="col-md-8 col-sm-8 col-6" style="display: inline-block; padding: 0px;">
                <select class="form-control wid75" [(ngModel)]="newLedger.customerId"
                    style="padding-left: 0px !important; cursor: pointer;">
                    <option value="0">Select</option>
                    <option *ngFor="let c of customers | sort : 'Cmp' : 0" [value]="c.RI">
                        {{c.Cmp == '-' ? c.Name : c.Cmp + ' / ' + c.Name}} 
                    </option>
                </select>
                <!-- <input class="form-control wid100" list="customers" [(ngModel)]="newLedger.customerName"
                       placeholder="Select Customer" (blur)="customerChange();">
                <datalist id="customers">
                    <option *ngFor="let c of customers | sort : 'CompanyName' : 0" [value]="c.CompanyName">
                        {{c.CompanyName}}
                    </option>
                </datalist> -->
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;" *ngIf="newLedger.type == 2">
            <div class="col-md-4 col-sm-4 col-4" style="padding: 0px; display: inline-block; color: #333333;">Supplier :
            </div>
            <div class="col-md-8 col-sm-8 col-6" style="display: inline-block; padding: 0px;">
                <select class="form-control wid75" [(ngModel)]="newLedger.supplierId"
                    style="padding-left: 0px !important; cursor: pointer;">
                    <option value="0">Select</option>
                    <option *ngFor="let s of suppliers | sort : 'Cmp' : 0" [value]="s.RI">
                        {{s.Cmp}}</option>
                </select>
                <!-- <input class="form-control wid100" list="supplierList" [(ngModel)]="newLedger.supplierName"
                       placeholder="Select Supplier" (blur)="supplierChange();">
                <datalist id="supplierList">
                    <option *ngFor="let c of suppliers | sort : 'CompanyName' : 0" [value]="c.CompanyName">
                        {{c.CompanyName}}
                    </option>
                </datalist> -->
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px;" *ngIf="newLedger.type == 3">
            <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
                <div class="col-md-4 col-sm-4 col-4" style="padding: 0px; display: inline-block; color: #333333;">
                    Bank Name :
                </div>
                <div class="col-md-8 col-sm-8 col-6" style="display: inline-block; padding: 0px;">
                    <input type="text" class="form-control" [(ngModel)]="bank.name" />
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
                <div class="col-md-4 col-sm-4 col-4" style="padding: 0px; display: inline-block; color: #333333;">Branch
                    :</div>
                <div class="col-md-8 col-sm-8 col-6" style="display: inline-block; padding: 0px;">
                    <input type="text" class="form-control" [(ngModel)]="bank.branch" />
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
                <div class="col-md-4 col-sm-4 col-4" style="padding: 0px; display: inline-block; color: #333333;">IFSC :
                </div>
                <div class="col-md-8 col-sm-8 col-6" style="display: inline-block; padding: 0px;">
                    <input type="text" class="form-control" [(ngModel)]="bank.ifsc" />
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
                <div class="col-md-4 col-sm-4 col-4" style="padding: 0px; display: inline-block; color: #333333;">
                    Account No :
                </div>
                <div class="col-md-8 col-sm-8 col-6" style="display: inline-block; padding: 0px;">
                    <input type="text" class="form-control" [(ngModel)]="bank.accNo" />
                </div>
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12 nozero"
            style="padding: 0px; margin-top: 15px; cursor: pointer; font-size: 13px; color: #1F628E;"
            *ngIf="!isShowZeroBal && newLedger.type == 0" (click)="isShowZeroBal = !isShowZeroBal">
            Set non-zero opening balance
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;" *ngIf="isShowZeroBal">
            <div class="col-md-4 col-sm-3 col-4" style="padding: 0px; display: inline-block; color: #333333;">
                Opening (₹) :
            </div>
            <div class="col-md-3 col-sm-3 col-3" style="display: inline-block; padding-left: 0px;">
                <input type="text" class="form-control" style="text-align: right; width: inherit;"
                    [(ngModel)]="newLedger.openingBal">
            </div>
            <div class="col-md-3 col-sm-3 col-3" style="display: inline-block;">
                <select class="form-control wid75" [(ngModel)]="newLedger.curr" style="padding-left: 0px !important;">
                    <option value="Db">Db</option>
                    <option value="Cr">Cr</option>
                </select>
            </div>
        </div>
    </div>
    <!--Footer-->
    <div class="" style="padding: 15px; border: none; text-align: left; float: left; padding-top: 0px;">
        <span class="btn btn-save brdrRadius3" style="padding: 3px 14px 3px; line-height: 1.66em; font-size: 13px;" (click)="saveLedger()"  *ngIf="right.AcctsCfg">
            <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
            <span>Save</span>
        </span>
    </div>
</ng-template>
<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">

</ngx-spinner>


<ng-template #myModal let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title"><span id="ApntmntHdr">Audit Trail</span></h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeModal()" ></i>                       
                </div>
            </div>              
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <div class="col-md-12" style="padding: 0px 15px 15px 15px;">
            <div *ngFor="let h of voucherHistoryData let i = index" class="col-md-12 col-12 col-sm-12 {{changeColor(i % 7)}} " style="cursor: pointer; border-radius: 5px !important; height: auto; border: none !important; padding: 8px 15px 8px 15px !important; margin-bottom: 10px; display:inline-flex;cursor: pointer;" (click)="printVoucherHistory(h.VoucherHistoryID);">
                <div class="col-md-11 col-11 col-sm-11" style="font-size: 13px; display: inline-block;padding: 0px;">
                    <span>{{h.userName}}</span>
                    <span style="float: right;">{{h.CreatedDT}}</span>
                </div>
                <div class="col-md-1 col-1 col-sm-1" (click)="printVoucherHistory(h.VoucherHistoryID);" style="text-align: right;display: inline-block;padding: 0px;">
                    <div style="font-size: 13px;">
                        <i class="zmdi zmdi-print" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
            <div *ngIf="voucherHistoryData.length == 0" class="nrf"> No history data. </div>
        </div>
    </div>
</ng-template>